import React, { useState, useEffect } from "react";
import "./App.css";
import { BrowserRouter, Link, Route, Routes } from "react-router-dom";

import Home from "./screens/Home";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route index element={<Home />} />
        {/* <Route path="/:prod" element={<Home />} /> */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;
